import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_MATERIAL } from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class MaterialValidator extends BaseValidator {
  properties = [
                 'name',
               ];
  validName(){
    let name = this.newVal.inputs.name.value;
    let isValid = this.require('name', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
}
export const validMaterial = function*(){
  yield takeEvery(VALID_MATERIAL, function*(action: FSA<any, any>){
    let validator;
    validator = new MaterialValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('name')){
      validator.validName();
    }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
